"use strict";
/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeBatchClient
 * @description  CalendarEventRsvpInvitationTypeBatchClient provides an easy way to consume CalendarEventRsvpInvitationTypeBatch REST API end-points. In order to obtain needed routes `calendarEventRsvpInvitationTypeBatchClient` uses `calendarEventRsvpInvitationTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventRsvpInvitationTypeBatchClient = /** @class */ (function () {
    function CalendarEventRsvpInvitationTypeBatchClient(calendarEventRsvpInvitationTypeBatchRoute, apiClient) {
        this.calendarEventRsvpInvitationTypeBatchRoute = calendarEventRsvpInvitationTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpInvitationTypeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeInvitationTypes action has been performed; this action creates new CalendarEventRsvpAttendeeInvitationType resources.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeInvitationTypes action has been performed.
     * @example calendarEventRsvpInvitationTypeBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeInvitationTypes action has been performed; this action updates CalendarEventRsvpAttendeeInvitationType resources.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType objects used to update specified CalendarEventRsvpAttendeeInvitationType resources.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeInvitationTypes action has been performed.
     * @example calendarEventRsvpAttendeeInvitationTypes are resources previously fetched using get action.
                calendarEventRsvpInvitationTypeBatchClient.update(calendarEventRsvpAttendeeInvitationTypes)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventRsvpInvitationType resources from the system if successfully completed.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType Ids which uniquely identify CalendarEventRsvpAttendeeInvitationType resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeInvitationTypeIds are identifiers which uniquely identify CalendarEventRsvpAttendeeInvitationType resources.
                calendarEventRsvpInvitationTypeBatchClient.remove(calendarEventRsvpAttendeeInvitationTypeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventRsvpInvitationTypeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpInvitationTypeBatchRoute !== "undefined" && __1.CalendarEventRsvpInvitationTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventRsvpInvitationTypeBatchClient);
    return CalendarEventRsvpInvitationTypeBatchClient;
}());
exports.CalendarEventRsvpInvitationTypeBatchClient = CalendarEventRsvpInvitationTypeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
